module.exports = __webpack_public_path__ + "static/CircularPro-Book.fcea822f.woff2";


//////////////////
// WEBPACK FOOTER
// ./public/fonts/CircularPro-Book.woff2
// module id = 726
// module chunks = 168707334958949